import React, {useState} from 'react';
import ChantierUpdateView from './ChantierUpdateView';
import {updateChantier, addChantier} from '../../../services/MadricService';
import Spinner from '../../Spinner/Spinner';

/**
 * Permet de modifier ou d'ajouter un chantier
 * @param {*} props props
 * @return {JSX}
 */
function ChantierUpdate(props) {
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useState({
    id: props.isUpdate ? props.selectedPlace.id : '',
    client_name: props.isUpdate ? props.selectedPlace.client_name : '',
    name: props.isUpdate ? props.selectedPlace.name : '',
    phone: props.isUpdate ? props.selectedPlace.phone : '',
    contrat: props.isUpdate ? props.selectedPlace.contrat : ''});

  const [error, setError] = useState('');


  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  /**
   * Permet d'envoyer le formulaire
   * @param {*} event event
   */
  async function handleSubmit(event) {
    event.preventDefault();

    setError('');
    let errors = false;

    if (form.name === '' || form.name === null) {
      errors = true;
      setError('L\'adresse ne peut pas être vide.');
    }

    if (!errors) {
      if (props.isUpdate) {
        setIsLoading(true);

        props.setPlaces((previous) => previous.map((item) => {
          if (item.id === props.selectedPlace.id) {
            return form;
          }
          return item;
        }));
        await updateChantier(props.selectedPlace.id, form);

        setIsLoading(false);
      } else {
        setIsLoading(true);

        const id = await addChantier(form);

        setIsLoading(false);
        form.id = id;
        props.setPlaces((previous) => [form, ...previous]);
      }

      props.closeModal();
    }
  };

  return (
    <div>
      {isLoading && <Spinner />}
      <ChantierUpdateView
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        closeModal={props.closeModal}
        error={error}
        isUpdate={props.isUpdate}
        form={form}/>
    </div>
  );
}

export default ChantierUpdate;
